import state from './reporting.state'
import mutations from './reporting.mutations'
import actions from './reporting.actions'

export default {
  state,
  mutations,
  actions
}
